<template>
  <div class="search-view">
    <div class="search-view--input is-aligned is-space-between m-horizontal-15">
      <input 
        v-model="search"
        ref="input"
      >

      <div class="m-right-20">
        <i class="uil uil-search"></i>
      </div>
    </div>

    <div 
      class="search-view--results"
      ref="container" 
    >
      <div class="search-view--pagination">
        <div 
          v-for="index in results.length"
          :key="index"
          :class="[
            'search-view--pagination-item',
            {
              'is-current-page': index - 1 === skip,
            }
          ]"
        ></div>
      </div>

      <div 
        v-for="(page, pageIndex) in results"
        :key="pageIndex"
        class="search-view--results-page is-grid"
        :style="{
          left: `${pageIndex * 100}%`,
          transform: `translate3d(-${100 * skip}%, 0, 0)`,
        }"
      >
        <b-user-badge
          v-for="(user, index) in page"
          :key="user.image"
          :class="[{
            'is-col-6': (index + 1) % 3 !== 0,
            'is-col-12': (index + 1) % 3 === 0,
          }]"
          :user="user"
        ></b-user-badge>
      </div>

      <div 
        v-if="!results.length && search"
        class="is-centered m-top-50"
      >
        <p>Chargement...</p>
      </div>
    </div>

    <div class="search-view--pagination">
      
    </div>
  </div>
</template>

<script>
  import { reactive, toRefs, computed, ref, onMounted, nextTick, customRef, onBeforeUnmount } from 'vue'
  import Hammer from 'hammerjs'
  import users from '@assets/data/users'

  function useDebouncedRef(value) {
    let timeout = null 
    let delay = 200 

    return customRef((track, trigger) => {
      return {
        get() {
          track()
          return value
        },
        set(newValue) {
          clearTimeout(timeout)
          timeout = setTimeout(() => {
            value = newValue
            trigger()
          }, delay)
        }
      }
    })
  }

  export default {
    setup () {

      const state = reactive({
        search: '', // useDebouncedRef(''),
        skip: 0,
        limit: 6,
        results: computed(() => {
          if (!/^beno.{1}t/i.test(state.search)) {
            return []
          }

          const allMatches = users.filter(user => 
            state.search && /^beno.{1}t/i.test(user.name)
          )
          const pages = [[]]

          let currentPageIndex = 0
          allMatches.forEach((user, index) => {
            pages[currentPageIndex].push(user)

            if (index !== allMatches.length - 1 && (index + 1) % state.limit === 0) {
              currentPageIndex++
              pages.push([])
            }
          })

          return pages
        }),
      })

      const container = ref(null)
      const input = ref(null)
      let hammer = null

      function onSwipe (event) {
        const isRight = event.direction === Hammer.DIRECTION_LEFT
        const isLeft = event.direction === Hammer.DIRECTION_RIGHT
        const hasRight = state.skip < state.results.length - 1
        const hasLeft = state.skip > 0

        if (hasRight && isRight) {
          state.skip += 1 
        } else if (hasLeft && isLeft) {
          state.skip -= 1 
        }
      }

      onMounted(() => {
        nextTick(() => {
          input.value && input.value.focus()

          hammer = new Hammer.Manager(container.value, {
            recognizers: [
              [Hammer.Swipe, { direction: Hammer.DIRECTION_HORIZONTAL }],
            ]
          })

          hammer.on('swipe', onSwipe)
        })
      })

      onBeforeUnmount(() => {
        hammer && hammer.destroy()
      })

      return {
        ...toRefs(state),
        container,
        input,
      }
    },
  }
</script>

<style lang="scss">
  .search-view {
    position: relative;
    height: 100%;

    &--input {
      position: relative;
      height: 30px;
      margin-bottom: 5px;
      border: 1px solid var(--color);
      padding: 1rem 0;
      border-radius: 10px;
      
      input {
        margin: 0;
        padding-left: 1rem;
        font-size: 18px;
        border: none;
        height: 30px;
        min-width: 50%; 
        background: transparent;

        &:focus, &:active {
          outline: none;
          border: none;
        }
      }

      i {
        font-size: 24px;
      }
    }

    &--results {
      position: relative;
      height: calc(100% - 35px);
      width: 100%;
      max-width: 100vw;
      // overflow: auto;
      overflow: hidden;

      &-page {
        position: absolute;
        top: 0px;
        height: calc(100% - 20px);
        width: 100%;
        transition: transform 0.3s $magic-animation;
      }
    }

    &--pagination {
      position: absolute;
      display: flex;
      width: 100%;
      justify-content: center;
      align-items: center;
      bottom: 0px;
      height: 10px;
      z-index: 99999;

      &-item {
        position: relative;
        height: 10px;
        width: 10px;
        border-radius: 100%;
        margin: 0 5px;
        background: rgba(black, 0.5);

        &.is-current-page {
          background: rgba(black, 1);
        }
      }
    }
  }
</style>